export { SolarIcon } from './SolarIcon';
export { SolarIcon as default } from './SolarIcon';
